import H from "history";
import {
    CommandBarButton,
    DatePicker,
    DefaultButton,
    Dialog,
    DialogFooter,
    Dropdown,
    IDropdownOption,
    MessageBar,
    MessageBarType,
    PrimaryButton
} from "office-ui-fabric-react";
import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import IHostedSalamanderConfig from '../../../../../models/hosted-salamander/IHostedSalamanderConfig';
import { IRootState } from "../../../../../store";
import DispatchProps from "../../../../../utils/DispatchProps";
import ApiService from "../../../../ApiService";
import LoadingCard from "../../../../LoadingCard";
import Actions from "../../../../../redux/Actions";
import { Link } from "react-router-dom";
import { Label } from "office-ui-fabric-react/lib-commonjs";
import { UserAccessLevel, userAccessLevelIsAtLeast } from "../../../../../models/UserAccessRecord";
import moment from "moment";
import SchoolInfoHeader from "../../../../SchoolInfoHeader";
import SchoolPageTitle from "../../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../../AdminSchoolMenu";

interface HostedSalamanderConfigPageProps {
    apiService: ApiService;
    history: H.History;

    tenantId: string;
    schoolCode: string;

    usersCdbAccessLevel?: UserAccessLevel;
}

interface HostedSalamanderConfigPageState {
    hostedSalamanderConfig?: IHostedSalamanderConfig,
    misNames: string[];
    loading: boolean;
    showDeleteDialog: boolean;
}

class HostedSalamanderConfigPage extends Component<HostedSalamanderConfigPageProps & DispatchProps, HostedSalamanderConfigPageState> {
    static displayName = HostedSalamanderConfigPage.name;

    constructor(props: HostedSalamanderConfigPageProps & DispatchProps) {
        super(props);

        this.state = {
            misNames: [],
            loading: false,
            showDeleteDialog: false,
        }
    }

    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps: Readonly<HostedSalamanderConfigPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    async load() {
        this.setState({
            loading: true,
            hostedSalamanderConfig: undefined,
            misNames: []
        });

        try {
            const misNames = await this.props.apiService.getMisNames(this.props.tenantId, this.props.schoolCode);
            const hostedSalamanderConfig = await this.props.apiService.getHostedSalamanderConfig(this.props.tenantId, this.props.schoolCode);

            this.setState({
                hostedSalamanderConfig: hostedSalamanderConfig == null ? {tenantId: this.props.tenantId,schoolCode: this.props.schoolCode,misName: "",minEffectiveDate: null} : hostedSalamanderConfig!,
                misNames: misNames
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading Hosted Salamander Config`, MessageBarType.error));
        }

        this.setState({
            loading: false
        });
    }

    async save() {
        if (this.state.hostedSalamanderConfig !== undefined) {
            this.setState({
                loading: true,
            });

            try {
                await this.props.apiService.addOrUpdateHostedSalamanderConfig(this.state.hostedSalamanderConfig);
                this.props.dispatch(Actions.showMessageBar(`Saved Hosted Salamander Config`, MessageBarType.success));
            }
            catch (e) {
                this.props.dispatch(Actions.showMessageBar(`Error saving Hosted Salamander Config: ${e.message}`, MessageBarType.error));
            }

            this.setState({
                loading: false,
            });
        }
    }

    misDropdownOptions(): IDropdownOption[] {
        return this.state.misNames.map(misName => {
            return {
                text: misName,
                key: misName
            }
        });
    }

    misDropDownOptionsMessageBar() {
        if (this.state.misNames.length < 1) {
            return (
                <MessageBar
                    className={"message-bar--inner-text-flex"}
                    messageBarType={MessageBarType.warning}
                    isMultiline={true}>
                    <span>No MIS Connections have been added</span>
                </MessageBar>
            );
        }
        return null;
    }

    private renderConfig(): JSX.Element {
        return (
            <div className="card">
                <div className={"card__header"}>
                    <div className={"card__title"}>
                        <span>Hosted Salamander Config</span>
                    </div>
                    <CommandBarButton
                        text="Save"
                        disabled={this.state.loading}
                        iconProps={{ iconName: 'save' }}
                        onClick={() => this.save()}
                    />
                </div>
                {this.misDropDownOptionsMessageBar()}
                <div className={"card__content"}>
                    <Dropdown
                        label="MIS"
                        disabled={this.state.loading || this.state.misNames.length < 1}
                        selectedKey={this.state.hostedSalamanderConfig?.misName}
                        onChange={(e, newValue) => {
                            const hostedSalamanderConfig = Object.assign({}, this.state.hostedSalamanderConfig, { misName: newValue!.key as string });
                            this.setState({
                                hostedSalamanderConfig: hostedSalamanderConfig
                            });
                        }}
                        options={this.misDropdownOptions()}
                    />
                    
                    <Label>
                        <Link to={`/cdb-admin/mis-connection-details/${this.props.tenantId}/${this.props.schoolCode}`}>
                            Manage MIS connection details
                        </Link>
                    </Label>
                    
                    <div className={"flex-row flex--align-items-flex-end"}>
                        <DatePicker
                            label={"Min Effective Date (leave blank unless needed)"}
                            value={this.state.hostedSalamanderConfig?.minEffectiveDate != null ? moment(this.state.hostedSalamanderConfig.minEffectiveDate).toDate() : undefined}
                            onSelectDate={(value) => {

                                let newMinEffectiveDate = value ? moment(value).format("YYYY-MM-DD") : null;

                                const hostedSalamanderConfig = Object.assign({}, this.state.hostedSalamanderConfig, { minEffectiveDate: newMinEffectiveDate});
                                this.setState({
                                    hostedSalamanderConfig: hostedSalamanderConfig
                                });
                            }}
                        />
                        <DefaultButton
                            className={"m-left-1rem"}
                            text="Clear"
                            onClick={() => {
                                const hostedSalamanderConfig = Object.assign({}, this.state.hostedSalamanderConfig, { minEffectiveDate: null});
                                this.setState({
                                hostedSalamanderConfig: hostedSalamanderConfig
                                });
                            }}
                        />              
                    </div>
                    
              
                </div>
            </div>
        );
    }

    private renderDeleteConfigCard(): JSX.Element {
        const userIsAdmin = userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel)

        return (
            <div className="card">
                <div className={"card__header"}>
                    <div className={"card__title"}>
                        <span>Remove config</span>
                    </div>
                </div>
                <MessageBar
                    className={"message-bar--inner-text-flex"}
                    messageBarType={MessageBarType.blocked}
                    isMultiline={true}>
                    <span>This will delete the configuration above. MIS connection details will NOT be deleted.</span>
                </MessageBar>
                <div className={"card__content"}>
                <PrimaryButton
                        text="Remove"
                        disabled={!userIsAdmin}
                        onClick={async () => {
                            this.setState({
                                showDeleteDialog: true
                            });
                        }}
                    />
                </div>
            </div>
        );
    }

    private renderDeleteConfigDialog(): JSX.Element {

        const closeDialog = () => {
            this.setState({
                showDeleteDialog: false
            });
        }

        return (
            <Dialog
                hidden={!this.state.showDeleteDialog}
                onDismiss={closeDialog}
                dialogContentProps={{
                    title: `Remove this configuration`,
                    subText: "Are you sure?"
                }}>

                <DialogFooter>
                    <PrimaryButton onClick={async () => {
                            try {
                                this.setState({
                                    loading: true,
                                });

                                await this.props.apiService.deleteHostedSalamanderConfig(this.props.tenantId, this.props.schoolCode);
                                this.props.dispatch(Actions.showMessageBar(`Removed hosted salamander config`, MessageBarType.success));
                                this.props.history.push(`/cdb-admin/mis-fetch/${this.props.tenantId}/${this.props.schoolCode}`);
                            }
                            catch (e) {
                                await this.props.dispatch(Actions.showMessageBar(`Failed to remove hosted salamander config: ${e.message}`, MessageBarType.error));
                                closeDialog();
                                this.setState({
                                    loading: false
                                });
                            }
                        }}
                        text="Remove"
                        disabled={this.state.loading}/>
                    <DefaultButton onClick={closeDialog} text="Cancel" disabled={this.state.loading} />
                </DialogFooter>

            </Dialog>
        )
    }

    render() {
        if (this.state.hostedSalamanderConfig === undefined) {
            return <LoadingCard />;
        }

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Hosted Config" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <SchoolInfoHeader tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                {this.renderConfig()}
                {this.renderDeleteConfigCard()}
                {this.renderDeleteConfigDialog()}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): HostedSalamanderConfigPageProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
            history: state.history,
        };
    }
)(HostedSalamanderConfigPage)